import React from 'react';
import { useTranslation } from 'react-i18next';

import BasketPress from "../../../assets/images/BasketPress.png";
import Bottling from "../../../assets/images/Bottling.png";
import Corker from "../../../assets/images/Corker.png";
import SmallEquipmentsFilter from "../../../assets/images/SmallEquipmentsFilter.png";
import SmallEquipmentsLabelling from "../../../assets/images/SmallEquipmentsLabelling.png";
import SmallEquipmentsPump from "../../../assets/images/SmallEquipmentsPump.png";
import SmallEquipmentsDestemmer from "../../../assets/images/SmallEquipmentsDestemmer.png";
import WineCapsuleHeatShrinker from "../../../assets/images/WineCapsuleHeatShrinker.png";
import AmateurDestemmer from "../../../assets/images/AmateurDestemmer.png";

function SmallEquipments() {
  const { t } = useTranslation(); 

  const products = [
    {
      name: t("Basket Press"),
      description: t(
        "The tradition of the future. A compromise between tradition and modernity, hydraulic vertical press erases the constraints of older vertical presses. Aesthetically pleasing, mobile and space-saving, it fits perfectly into any cellar"
      ),
      image: BasketPress,
    },
    {
      name: t("Bottling"),
      description: t(
        "Bottling is essential as it indicates the finishing touches in the process of winemaking, our bottling equipment will allow you to make this operation easier and more comfortable."
      ),
      image: Bottling,
    },
    {
      name: t('Amateur Destemmer'),
      description: t('A simpler, but very effective and quality-oriented machine, which will allow the user to receive and process the product in the needed time.'),
      image: AmateurDestemmer, 
    },
    {
      name: t("Corker"),
      description: t(
        "A wine corker is a specialized tool that allows you to insert a cork into your bottle in a quick, easy, and safe manner. Corkers work by first compressing the cork, then inserting it into the bottle in a single motion."
      ),
      image: Corker,
    },
    {
      name: t("Filter"),
      description: t(
        "These filters consist of plastic plates which hang in a steel frame. The filtration media (stuff that actually does the filtering) are square pads (also called sheets) of cellulose fibers that are placed between the plates in the filter."
      ),
      image: SmallEquipmentsFilter,
    },
    {
      name: t("Labelling"),
      description: t(
        "Labelling is supposedly the final touch in the wine production, as it gives the product the visual character and defines its final appearance as well. Our labelling machines will help you guarantee the quality of labelling as well as make it easier."
      ),
      image: SmallEquipmentsLabelling,
    },
    {
      name: t("Pump"),
      description: t(
        "Quality and performance-oriented wine pump. This type of wine pump can run at different speeds and accommodate differing viscosity types. These pumps are a popular choice for winemakers given their versatility and low maintenance requirements."
      ),
      image: SmallEquipmentsPump,
    },
    {
      name: t("Destemmer"),
      description: t(
        "A simpler, but very effective and quality-oriented machine, which will allow the user to receive and process the product in the needed time."
      ),
      image: SmallEquipmentsDestemmer,
    },
    {
      name: t("Wine Capsule Heat Shrinker"),
      description: t(
        "A special device which allows you to simplify the wine capsuling process via the heat shrinking method in an effective manner."
      ),
      image: WineCapsuleHeatShrinker,
    },
  ];

  return (
    <div className="main-infocontainer">
      {products.map((product, index) => (
        <div className="item-container" key={index}>
          <img src={product.image} alt={product.name} />
          <div className="text-info">
            <h1>{product.name}</h1>
            <p>{product.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default SmallEquipments;
